import { render, staticRenderFns } from "./FeedbackIcon.vue?vue&type=template&id=888ba370&scoped=true&"
import script from "./FeedbackIcon.vue?vue&type=script&lang=js&"
export * from "./FeedbackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888ba370",
  null
  
)

export default component.exports